import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const detailInnerSectionDefaultVariants = {}
const detailInnerSectionCompoundVariants = []

const detailInnerSectionSlotNames = [
  [
    "root",
    "detail-inner-section__root"
  ],
  [
    "content",
    "detail-inner-section__content"
  ],
  [
    "goto",
    "detail-inner-section__goto"
  ]
]
const detailInnerSectionSlotFns = /* @__PURE__ */ detailInnerSectionSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, detailInnerSectionDefaultVariants, getSlotCompoundVariant(detailInnerSectionCompoundVariants, slotName))])

const detailInnerSectionFn = memo((props = {}) => {
  return Object.fromEntries(detailInnerSectionSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const detailInnerSectionVariantKeys = []
const getVariantProps = (variants) => ({ ...detailInnerSectionDefaultVariants, ...compact(variants) })

export const detailInnerSection = /* @__PURE__ */ Object.assign(detailInnerSectionFn, {
  __recipe__: false,
  __name__: 'detailInnerSection',
  raw: (props) => props,
  variantKeys: detailInnerSectionVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, detailInnerSectionVariantKeys)
  },
  getVariantProps
})